<template>
  <transition name="fade">
    <div
      class="modal-container"
      v-scroll-lock="showingModal"
      v-if="showingModal"
    >
      <CustomerSupport v-if="showingModal === 'customer support'" />
      <PartnerForm v-if="showingModal === 'partner form'" />
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex"
import CustomerSupport from "./CustomerSupport"
import PartnerForm from "./PartnerForm"
export default {
  components: {
    CustomerSupport,
    PartnerForm,
  },
  computed: {
    ...mapGetters("Modals", ["showingModal"]),
  },
}
</script>

<style lang="scss" scoped>
.modal-container {
  background-color: rgba(0, 0, 0, 0.85);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 30;
  div {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/ModalContainer.vue